import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default function BasicCheckbox({
  isChecked = false,
  onChange,
  label = null,
  color = 'primary',
  disabled = false,
  id = null,
}) {
  const checkboxId =
    id || `checkbox-${Math.random().toString(36).substr(2, 9)}`;

  const colorClasses = {
    primary: {
      bg: 'bg-primary-500',
      border: 'border-primary-500',
      hover: 'hover:border-primary-600',
      focus: 'focus:ring-primary-500',
    },
    secondary: {
      bg: 'bg-secondary-500',
      border: 'border-secondary-500',
      hover: 'hover:border-secondary-600',
      focus: 'focus:ring-secondary-500',
    },
  };

  const colors = colorClasses[color] || colorClasses.primary;

  return (
    <div className="flex items-center">
      <div className="relative">
        <input
          type="checkbox"
          id={checkboxId}
          checked={isChecked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          className="sr-only peer"
        />
        <label
          htmlFor={checkboxId}
          className={classNames(
            'flex items-center justify-center w-5 h-5 border-2 rounded transition-all duration-200',
            {
              'opacity-50 cursor-not-allowed': disabled,
              'cursor-pointer': !disabled,
              [colors.bg]: isChecked,
              [colors.border]: isChecked,
              'border-gray-300': !isChecked,
              [colors.hover]: !disabled && !isChecked,
              'peer-focus:ring-2 peer-focus:ring-offset-2': !disabled,
              [colors.focus]: !disabled,
            },
          )}
        >
          {isChecked && (
            <svg
              className="w-3 h-3 text-white"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M5 13l4 4L19 7" />
            </svg>
          )}
        </label>
      </div>
      {label && (
        <label
          htmlFor={checkboxId}
          className={classNames(
            'ml-3 text-sm font-medium text-gray-700 cursor-pointer select-none',
            {
              'opacity-50 cursor-not-allowed': disabled,
            },
          )}
        >
          {label}
        </label>
      )}
    </div>
  );
}

BasicCheckbox.propTypes = {
  isChecked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  color: PropTypes.oneOf(['primary', 'secondary']),
  disabled: PropTypes.bool,
  id: PropTypes.string,
};
